import { css } from '@emotion/react';

export const cardStyles = css`
  background-color: var(--color-neutral-50);
  border-radius: var(--spacing-4);
  padding: var(--spacing-5);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
`;

export const stepRowStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
`;

export const pendingCircleStyles = css`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  border: 2px solid var(--color-neutral-300);
  box-sizing: border-box;
`;

export const activeTextStyles = css`
  background: linear-gradient(
    90deg,
    var(--color-neutral-700) 0%,
    var(--color-neutral-500) 50%,
    var(--color-neutral-700) 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: lt-shimmer 2s ease-in infinite;

  @keyframes lt-shimmer {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
`;

export const estimatedTimeStyles = css`
  font-style: italic;
`;
